<p-autocomplete
  [multiple]="true"
  [disabled]="disabled()"
  [(ngModel)]="locations"
  [suggestions]="locationList"
  (completeMethod)="search($event)"
  (onSelect)="onLocationChange($event.value)"
  (onUnselect)="onLocationChange($event.value)"
  minQueryLength="3"
  [showEmptyMessage]="true"
  [appendTo]="appendTo()"
>
  <ng-template let-location #item>
    @if (location) {
      <app-location-icon [kind]="location.getKind()"></app-location-icon>
    }
    {{ location.getName() }}
    @if (location && location.getKind() === locationKind.airport) {
      <span>, {{ location.getCode() }}</span>
    }
  </ng-template>
  <ng-template let-location #selecteditem>
    @if (location) {
      <app-location-icon [kind]="location.getKind()"></app-location-icon>
    }
    {{ location.getName() }}
    @if (location && location.getKind() === locationKind.airport) {
      <span>, {{ location.getCode() }}</span>
    }
  </ng-template>
  <ng-template #empty>
    <app-autocomplete-empty-message
      [loading]="loading()"
      text="Location not found"
    ></app-autocomplete-empty-message>
  </ng-template>
</p-autocomplete>
